import { createFeature, createReducer, on } from '@ngrx/store';
import { Permission } from '@qtek/shared/models';
import { PermissionsActions } from './permissions.actions';

export interface PermissionsState {
  permissions: Map<string, Permission>;
}

export const permissionsState: PermissionsState = {
  permissions: new Map<string, Permission>(),
};

export const PermissionsReducer = createReducer(
  permissionsState,
  on(PermissionsActions.setPermissions, (state, { permissions }) => ({
    ...state,
    permissions: new Map(permissions.map(p => [p.id, p])),
  }))
);

export const PermissionsFeature = createFeature({
  name: 'Permissions',
  reducer: PermissionsReducer,
});

export const { selectPermissions } = PermissionsFeature;
